/** Primo giorno del mese traslato di `months` rispetto al mese corrente (stesso uso del rental dashboard). */
export const getTransposedDateFirstOfMonth = (months) => {
    const today = new Date();
    const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    firstOfMonth.setMonth(firstOfMonth.getMonth() + months);

    const yyyy = firstOfMonth.getFullYear();
    const mm = String(firstOfMonth.getMonth() + 1).padStart(2, '0');
    const dd = String(firstOfMonth.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
};
